import { lazy, Suspense } from 'react';
import { Box } from '@mui/material';

// The editor pulls in tiptap/prosemirror (~1 MB of source), so it loads on first use instead of with the main bundle.
const Impl = lazy(() => import('./markdown-editor-impl.jsx'));

function MarkdownEditor(props) {
    return (
        <Suspense fallback={<Box sx={{ minHeight: 44 }} />}>
            <Impl {...props} />
        </Suspense>
    );
}

export { MarkdownEditor };
